<template>
	<view>
		<!-- 通知 -->
			<uni-notice-bar show-icon text="仅限对比出自爱康自有分院,且性别相同的体检报告哦!" />

		<!-- 选择报告 -->
		<div class="choice">
			<view class="uni-px-5 uni-pb-5">
				<uni-data-checkbox multiple v-model="checkbox1" :localdata="hobby" selectedColor="#fd8b4d"
					selectedTextColor="#fd8b4d"></uni-data-checkbox>
			</view>
		</div>

		<!-- 对比 -->
		<div class="contrast">
			<uni-goods-nav :fill="true" :options="options" :button-group="customButtonGroup1"
				style="margin-top: 20px;" />
			</uni-section>
		</div>



	</view>
</template>

<script>
	export default {
		data() {
			return {
				options: [],
				
				radio1: 0,
				radio2: 0,
				radio3: 0,
				radio4: 0,
				radio5: 0,
				radio6: 0,
				checkbox1: [0],
				checkbox2: [0],
				checkbox3: [0],
				checkbox4: [0],
				checkbox5: [0],
				checkbox6: [0],

				hobby: [{
					text: '2022-04-08  xxx 男',
					value: 0
				}, ],

				customButtonGroup1: [{
					text: '对比',
					backgroundColor: '#c8c8c8',
					color: '#fff'
				}, ]

			}
		},
		methods: {

		}
	}
</script>

<style>
	.choice {
		width: 100%;
		height: 100rpx;
		display: flex;
		align-items: center;
		background-color: #f8f8fa;
	}
	.contrast{
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
	}
</style>
